<template>
  <div>
    <datatable
      :show_load_ghana_flags_button="true"
      :show_sort_ghana_flags_button="false"
      :show_delete="false"
      title="Applicants"
      @thFilter="thFilter"
      @create="createCompany"
      @edit_leave="editLeave"
      @edit_hover="editHover"
      @edit_click="editClick"
      @sort="sort"
      @files="clickedFiles"
      @internal_notes="clickedInternalNotes"
      @index_grouped_by_green_offers="toggleFilterApplicantsByGreenOffers()"
      @recommendation="manageRecommendation"
      @position_recommendation="openPositionRecommendation"
      :unique_buttons="unique_buttons"
      :sorters="sorters"
      :filters="filters"
      :fields="fields"
      :response="data"
      :operations="operations"
      :working_th_searches="working_th_searches"
    >
    </datatable>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-applicants',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      filters_helper: filters_helper,
      fields: [
        {
          name: 'owner',
          value: 'resource.applicant.owner'
        },
        {
          name: 'full_name',
          value: 'full_name',
          component: 'LinkEntity',
          additional_data: { resource_type: 'Applicant' }
        },
        {
          name: 'active_at',
          value: 'active_at',
          is_time: true
        },
        {
          name: 'applicant_status',
          value: 'applicant_status',
          component: 'StartVetting'
        },
        {
          name: 'is_registered',
          value: 'is_registered'
        },
        {
          name: 'tags',
          value: 'tags',
          component: 'Tags'
        },
        {
          name: 'message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/users/',
            headers: 'admin_headers',
            resource_type: 'Applicant',
            isShowKeyWord: true
          }
        },
        {
          name: 'offers',
          component: 'GhanaFlag',
          additional_data: {
            resource_type: 'Applicant'
          }
        },
        {
          name: 'job_title',
          value: 'job_title'
        },
        {
          name: 'status',
          value: 'status'
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        },
        {
          name: 'email',
          value: 'email'
        },
        {
          name: 'applicant_id',
          value: 'resource.applicant.resource_id'
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        }
      ],
      filters: [
        {
          type: 'modal',
          designator: 'applicant_status',
          options: [
            { text: 'completed', value: 'completed' },
            { text: 'vetted', value: 'vetted' },
            { text: 'unvetted', value: 'unvetted' },
            { text: 'irrelevant', value: 'irrelevant' }
          ]
        },
        {
          type: 'single',
          designator: 'skills',
          options: this.dropdownFeaturedSkills
        },
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        },
        {
          type: 'multiple',
          designator: 'certification_date',
          options: []
        }
      ],
      sorters: [
        {
          designator: 'updated_at',
          value: '-updated_at'
        },
        {
          designator: '+updated_at',
          value: 'updated_at'
        },
        {
          designator: 'id',
          value: '-id'
        },
        {
          designator: '+id',
          value: '+id'
        },
        {
          designator: 'active_at',
          value: '-active_at'
        },
        {
          designator: 'sent_at',
          value: '-sent_at'
        },
        {
          designator: '+sent_at',
          value: 'sent_at'
        }
      ],
      unique_buttons: [
        {
          name: 'index_grouped_by_green_offers',
          display_text: '*',
          css_classes: {
            'is-green': () => true,
            'is-green-fill': () => this.$route.query.index_grouped_by_green_offers == 'true'
          }
        }
      ],
      data: [],
      th_filters: {},
      operations: [
        { name: 'position_recommendation' },
        { name: 'recommendation' },
        { name: 'internal_notes', icon: '/note.png' },
        { name: 'files', icon: '/files_icon.png' },
        { component: 'IsStar' },
        { component: 'IsWatch' },
        { component: 'ExtraAttributes' },
        {
          component: 'AlertButton',
          additional_data: { resource_type: 'Applicant' }
        },
        {
          component: 'CompletenessIndicator',
          component_data_path: 'resource.applicant',
          additional_data: { api_path: '/applicants/' }
        }
      ],
      working_th_searches: ['owner', 'full_name']
    }
  },
  created: function () {
    this.init()
    this.fetchAll()
    this.fetchAllSkills()
  },
  computed: {
    ...mapGetters('modals', ['findModal']),
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('skills', ['dropdownFeaturedSkills'])
  },
  watch: {
    dropdownAdmins (newValue) {
      this.watchTreeShaking(newValue, 'owner')
    },
    dropdownFeaturedSkills (newValue) {
      this.watchTreeShaking(newValue, 'skills')
    }
  },
  methods: {
    init () {
      this.getApplicants()
      this.getQuestionsFilters()
    },
    watchTreeShaking (newValue, designator) {
      this.filters.forEach(filter => {
        if (filter.designator == designator) {
          filter.options = newValue
        }
      })
    },
    getApplicants () {
      let request_params = {
        page: this.$route.query.page || 1,
        per: 100,
        sort: this.$route.query.sort || '-updated_at',
        full_name: this.$route.query.full_name,
        contains_text: this.$route.query.contains_text,
        text: this.$route.query.text,
        applicant_status: this.$route.query.applicant_status,
        ...this.filters_helper.getServerCallFilters(this.filters),
        ...this.th_filters
      }
      if (this.$route.query.index_grouped_by_green_offers) {
        this.$network_utils.getApplicantsByGreenOffers(request_params).then(response => {
          this.setData(response)
        })
      } else {
        this.$network_utils.getApplicants(request_params).then(response => {
          this.transformData(response)
        })
      }
    },
    transformData (response) {
      response = Array.isArray(response) ? response : [response]
      this.data = response.map(item => {
        return { ...item,
          resource: {
            type: 'applicant',
            applicant: {
              ...item
            }
          } }
      })
    },
    createCompany () {
      this.create({
        designator: 'create-applicant',
        component_name: 'ApplicantCreateForm',
        ignore_escape_button: true,
        modal_title: 'Create new Applicant'
      })
    },
    setData (response) {
      response = Array.isArray(response) ? response : [response]
      let data = []
      for (let i = 0; i < response.length; i++) {
        let applicant = response[i]
        applicant.full_name = `${applicant.first_name} ${applicant.last_name}`
        data.push(applicant)
      }
      this.data = data
    },
    toggleFilterApplicantsByGreenOffers () {
      let query_param_value = this.$route.query.index_grouped_by_green_offers
      let index_grouped_by_green_offers = query_param_value == undefined ? 'true' : undefined
      this.$router.push({ name: 'admin-applicants', query: { ...this.$route.query, index_grouped_by_green_offers } })
      this.init()
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getApplicants()
    },
    sort (sorter) {
      this.$router.push({ name: 'admin-applicants', query: { sort: sorter } })
      this.init()
    },
    clickedFiles (data) {
      this.create({ designator: 'files-modal', component_name: 'Files', applicant_data: data, applicant_id: data.resource_id, modal_title: data.first_name + ' ' + data.last_name + ' קבצים' })
    },
    openPositionRecommendation (data) {
      this.create({
        designator: 'position-recommendation-modal',
        component_name: 'PositionRecommendationModal',
        data: { applicant_id: data.resource_id, applicant_name: data.first_name + ' ' + data.last_name },
        modal_title: 'המלץ על משרות - ' + data.first_name + ' ' + data.last_name,
        modal_width: 1200,
        is_center_modal: true
      })
    },
    manageRecommendation (data) {
      this.create({
        designator: 'service-recommendation-modal',
        component_name: 'ServiceRecommendation',
        resource_type: 'Applicant',
        resource_id: data.resource_id,
        is_multiple: true,
        data: data,
        modal_title: data.first_name + ' ' + data.last_name + ' המלצה של'
      })
    },
    editHover (data) {
      this.create({ designator: 'applicant-info-modal', component_name: 'ApplicantInfo', data: data, modal_title: data.first_name + ' ' + data.last_name, modal_width: 1500, override_modal_x: 370 })
    },
    editLeave () {
      let applicant_info_modal = this.findModal({ type: 'designator', value: 'applicant-info-modal' })
      this.remove(applicant_info_modal)
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Applicant', resource_id: data.resource_id, modal_title: data.first_name + ' ' + data.last_name + ' הערות פנימיות' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-form-modal', component_name: 'ApplicantForm', data, modal_title: data.first_name + ' ' + data.last_name })
    },
    getQuestionsFilters () {
      this.$network_utils.getQuestions({ designators: 'certification_date,seniority,job_title', current_resource_id: 1, current_type: 'Applicant' }).then(response => {
        response.forEach(question => {
          question = this.getQuestionWithSortedOptions(question)
          this.addQuestionOptionsToFilters(question)
        })
        this.$forceUpdate()
      })
    },
    getQuestionWithSortedOptions (question) {
      question.options.sort((a, b) => b.option_order - a.option_order)
      return question
    },
    addQuestionOptionsToFilters (question) {
      let filter_options = question.options.map(option => {
        if (question.designator == 'certification_date') {
          return { text: option.text, value: option.text }
        }
        return { text: option.text, value: option.id.toString() }
      })
      this.filters = this.filters.map(filter => {
        if (filter.designator == question.designator) {
          return { ...filter, options: filter_options }
        }
        return filter
      })
    },
    ...mapActions('admins', ['fetchAll']),
    ...mapActions('skills', ['fetchAllSkills']),
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
